import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import { footerEn /* footerAr*/ } from '../data/footer'
import { researchTraining, navigationTop, navigationButtom } from '../params'
import ResearchTrainingTable from '../components/Compliance/ResearchTrainingTable';




const ResearchTrainingCourses = ({ updateLang }) => {
    const [htmlContent, setHtmlContent] = React.useState('');
    const [dynamicRoutes, setDynamicRoutes] = useState(researchTraining);

    document.title = 'On-Demand Nature Masterclasses Courses ';
    const headerData = {
        title: 'On-Demand Nature Masterclasses Courses ',
        crumb: [
            { link: '//', text: 'Home' },
            { link: '/', text: 'Research' },
            { link: '/research/online-training', text: 'Online Training' },
            { text: 'On-Demand Nature Masterclasses Courses ' },
        ],
        navigationButtom: researchTraining // Add this if you want bottom navigation as well
    };

    return (
        <>
            <Navigation
                {...headerData}
                // researchTraining={[]}
                updateLang={updateLang}
            />
            {/* <NewsBanner {...HeaderBanner} coreLab={true} /> */}
            <section className='space-block-60'>
                <div className='container'>
                  <ResearchTrainingTable />
                </div>
            </section>
            <Footer {...footerEn} />
        </>
    );
};

export default ResearchTrainingCourses;
